// extracted by mini-css-extract-plugin
module.exports = {"set_drop":"ScoreModal_set_drop__2Lu4_","score_div":"ScoreModal_score_div__NdQPs"};